<template>
    <div class="row">
      <div class="col-xl-6 mb-xl-0 mb-3">
          <div class="bg-white rounded-4 p-4">
              <h3 class="fs-5 fw-bold mb-4">الملف الشخصي</h3>
              <div class="d-flex align-items-center gap-3 mb-5">
                  <img src="assets/images/profile.png" alt="" width="120" height="120" class="img-fluid">
                  <div>
                      <!-- <h5 class="fs-5 fw-bold text-center">{{ user.name }}</h5> -->
                      <!-- <p class="text-muted">
                          <small>انضم في {{ user.created_at }}</small>
                      </p>
                      <button class="btn btn-sm btn-light">تعديل الملف الشخصي</button> -->
                  </div>
              </div>
              <div class="d-flex gap-3 mb-4">
                  <div
                          class="d-flex flex-column align-items-center justify-content-around border rounded-4 p-3 w-100"
                          style="height: 136px"
                  >
                      <span class="bi bi-bell-fill fs-5 text-success"></span>
                      <span class="fs-4 fw-bold">{{ reminderOrdersCount }}</span>
                      <small class="text-muted">رسائل التذكير</small>
                  </div>
                  <div
                          class="d-flex flex-column align-items-center justify-content-around border rounded-4 p-3 w-100"
                          style="height: 136px"
                  >
          <span
                  class="bi bi-check-circle-fill fs-5 text-warning"
          ></span>
                      <!-- <span class="fs-4 fw-bold">{{ contactSuggestStatistics }}</span>
                      <small class="text-muted">طلبات الاقتراحات</small> -->
                      <span class="fs-4 fw-bold">{{ realestatesVacant }}</span>
                      <small class="text-muted">وحدات شاغرة</small>
                  </div>
                  <div
                          class="d-flex flex-column align-items-center justify-content-around border rounded-4 p-3 w-100"
                          style="height: 136px"
                  >
          <span class="text-danger fs-5">
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1em"
                    height="1em"
                    viewBox="0 0 1024 1024"
                    fill="currentColor"
            >
              <path
                      d="M1024 512c-0.132 22.622-1.709 44.744-4.646 66.435l0.293-2.643c-0.622 5.182-1.555 10.364-2.384 15.236-3.212 20.756-6.951 38.272-11.551 55.435l0.824-3.613c-0.829 3.006-1.451 6.063-2.28 9.017-49.89 170.748-181.639 302.498-348.761 351.477l-3.628 0.911c-2.954 0.829-6.011 1.451-9.017 2.28-13.573 3.787-31.090 7.526-48.911 10.347l-2.911 0.38c-5.182 0.829-10.364 1.71-15.236 2.384-19.049 2.644-41.171 4.222-63.637 4.352l-0.156 0.001c-22.622-0.132-44.744-1.709-66.435-4.646l2.643 0.293c-5.182-0.622-10.364-1.555-15.547-2.384-20.756-3.212-38.272-6.951-55.436-11.551l3.614 0.824c-2.954-0.829-6.011-1.451-8.965-2.28-170.748-49.89-302.498-181.639-351.477-348.761l-0.911-3.628c-0.829-2.954-1.555-6.011-2.28-9.017-3.787-13.573-7.526-31.090-10.347-48.911l-0.38-2.911c-0.777-5.182-1.658-10.364-2.384-15.236-2.57-19.125-4.056-41.266-4.094-63.747v-0.046c0.132-22.622 1.709-44.744 4.646-66.435l-0.293 2.643c0.622-5.182 1.555-10.364 2.384-15.547 3.204-20.667 6.978-38.179 11.642-55.324l-0.812 3.502c0.726-2.539 1.451-5.804 2.28-8.758 49.809-170.795 181.594-302.58 348.766-351.481l3.623-0.908c2.954-0.829 6.011-1.555 8.965-2.28 13.538-3.802 31.048-7.575 48.863-10.439l2.959-0.392c5.182-0.777 10.364-1.658 15.547-2.384 18.971-2.583 40.977-4.106 63.32-4.197h0.11c22.622 0.132 44.744 1.709 66.435 4.646l-2.643-0.293c5.182 0.622 10.364 1.555 15.236 2.384 20.667 3.204 38.179 6.978 55.324 11.642l-3.502-0.812c3.006 0.777 6.063 1.451 9.017 2.28 170.748 49.89 302.498 181.639 351.477 348.761l0.911 3.628c0.829 2.954 1.451 6.011 2.28 8.965 3.776 13.55 7.515 31.066 10.343 48.885l0.384 2.937c0.829 5.182 1.71 10.364 2.384 15.547 2.633 18.931 4.21 40.925 4.352 63.261l0.001 0.169zM214.594 395.66l-95.404-95.093c-34.289 60.982-54.686 133.771-55.19 211.283l-0.001 0.151c0.476 77.715 20.876 150.562 56.342 213.825l-1.152-2.236 95.145-95.145c-14.301-34.443-22.606-74.448-22.606-116.392s8.305-81.949 23.361-118.459l-0.755 2.067zM512 960c77.731-0.525 150.573-20.978 213.818-56.496l-2.229 1.15-95.145-95.249c-34.441 14.314-74.446 22.627-116.392 22.627s-81.951-8.313-118.456-23.381l2.064 0.755-95.093 95.145c60.956 34.404 133.742 54.893 211.268 55.448l0.165 0.001zM512 64c-77.662 0.504-150.451 20.901-213.669 56.342l2.236-1.151 95.093 95.404c34.429-14.288 74.415-22.586 116.34-22.586s81.911 8.298 118.408 23.34l-2.067-0.755 95.197-95.404c-61.007-34.324-133.839-54.726-211.398-55.19l-0.139-0.001zM758.517 446.549c-24.083-88.589-92.435-156.958-179.225-180.649l-1.789-0.416q-12.8-3.42-25.911-5.493c-11.918-2.522-25.612-3.967-39.644-3.967s-27.726 1.444-40.942 4.192l1.298-0.226c-100.49 16.343-180.375 89.441-206.404 184.768l-0.417 1.791c-1.906 6.73-3.819 15.481-5.285 24.382l-0.208 1.529c-2.522 11.918-3.967 25.612-3.967 39.644s1.444 27.726 4.192 40.942l-0.226-1.298c1.625 10.329 3.539 19.082 5.902 27.647l-0.409-1.736c24.088 88.59 92.466 156.95 179.278 180.599l1.787 0.415c6.73 1.906 15.481 3.819 24.382 5.285l1.529 0.208c11.863 2.425 25.56 3.89 39.572 4.041l0.123 0.001c14.108-0.168 27.77-1.612 41.013-4.224l-1.421 0.234c10.329-1.625 19.082-3.539 27.647-5.902l-1.736 0.409c88.589-24.060 156.954-92.425 180.599-179.227l0.415-1.787q3.368-12.8 5.493-25.911c2.425-11.863 3.89-25.56 4.041-39.572l0.001-0.123c-0.168-14.145-1.613-27.843-4.224-41.123l0.234 1.428c-1.76-10.461-3.742-19.202-6.145-27.766l0.445 1.855zM904.654 300.567l-95.249 95.093c14.308 34.426 22.618 74.412 22.618 116.34s-8.31 81.915-23.372 118.403l0.754-2.063 95.249 95.145c34.396-60.974 54.855-133.787 55.345-211.339l0.001-0.146c-0.553-77.679-21.003-150.463-56.497-213.663l1.151 2.23z"
              ></path>
            </svg>
          </span>
                      <!-- <span class="fs-4 fw-bold">{{ contactSupportStatistics }}</span>
                      <small class="text-muted">طلبات الدعم</small> -->
                      <span class="fs-4 fw-bold">{{ realestatesRent }}</span>
                      <small class="text-muted">وحدات مؤجرة</small>
                  </div>
              </div>
              <div class="mb-4 rounded-3 border px-3 pt-3 pb-2">
                  <div
                          class="d-flex gap-3 flex-column flex-sm-row justify-content-between"
                  >
                      <div class="d-flex align-items-center gap-3">
                          <div
                                  class="rounded-3 fs-5 text-white bg-success"
                                  style="padding: 0.4rem 0.75rem"
                          >
                              <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="1em"
                                      height="1em"
                                      viewBox="0 0 32 32"
                                      fill="currentColor"
                              >
                                  <path
                                          d="M9.332 13.334h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736 0.596-1.332 1.332-1.332 0.001 0 0.001 0 0.002 0h16c0 0 0.001 0 0.002 0 0.736 0 1.332 0.596 1.332 1.332 0 0.001 0 0.001 0 0.002v-0 8h-2.668v-6.668h-13.334z"
                                  ></path>
                                  <path
                                          d="M30.666 10.666h-12c-0 0-0.001 0-0.002 0-0.736 0-1.332 0.596-1.332 1.332 0 0.001 0 0.001 0 0.002v-0 17.332h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736-0.596-1.332-1.332-1.332-0.001 0-0.001 0-0.002 0h-11.998c-0 0-0.001 0-0.002 0-0.736 0-1.332 0.596-1.332 1.332 0 0.001 0 0.001 0 0.002v-0 13.334c0 0 0 0.001 0 0.002 0 0.736 0.596 1.332 1.332 1.332 0.001 0 0.001 0 0.002 0h29.332c0 0 0.001 0 0.002 0 0.736 0 1.332-0.596 1.332-1.332 0-0.001 0-0.001 0-0.002v0-18.666c0-0.001 0-0.001 0-0.002 0-0.736-0.596-1.332-1.332-1.332-0.001 0-0.001 0-0.002 0h0zM9.334 28h-4v-2.668h4zM9.334 22.666h-4v-2.666h4zM26.668 28h-4.002v-2.668h4zM26.668 22.666h-4.002v-2.666h4zM26.668 17.332h-4.002v-2.666h4z"
                                  ></path>
                              </svg>
                          </div>
                          <div>
                              <dl class="mb-0">
                                  <dt class="d-block">طلبات الدعم</dt>
                                  <dd class="mb-0 fs-4 fw-bold">{{ contactSupportStatistics }}</dd>
                              </dl>
                          </div>
                      </div>
                      <div class="d-flex align-items-center gap-3">
                          <div
                                  class="rounded-3 fs-5 text-white bg-warning"
                                  style="padding: 0.4rem 0.75rem"
                          >
                              <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="1em"
                                      height="1em"
                                      viewBox="0 0 32 32"
                                      fill="currentColor"
                              >
                                  <path
                                          d="M9.332 13.334h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736 0.596-1.332 1.332-1.332 0.001 0 0.001 0 0.002 0h16c0 0 0.001 0 0.002 0 0.736 0 1.332 0.596 1.332 1.332 0 0.001 0 0.001 0 0.002v-0 8h-2.668v-6.668h-13.334z"
                                  ></path>
                                  <path
                                          d="M30.666 10.666h-12c-0 0-0.001 0-0.002 0-0.736 0-1.332 0.596-1.332 1.332 0 0.001 0 0.001 0 0.002v-0 17.332h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736-0.596-1.332-1.332-1.332-0.001 0-0.001 0-0.002 0h-11.998c-0 0-0.001 0-0.002 0-0.736 0-1.332 0.596-1.332 1.332 0 0.001 0 0.001 0 0.002v-0 13.334c0 0 0 0.001 0 0.002 0 0.736 0.596 1.332 1.332 1.332 0.001 0 0.001 0 0.002 0h29.332c0 0 0.001 0 0.002 0 0.736 0 1.332-0.596 1.332-1.332 0-0.001 0-0.001 0-0.002v0-18.666c0-0.001 0-0.001 0-0.002 0-0.736-0.596-1.332-1.332-1.332-0.001 0-0.001 0-0.002 0h0zM9.334 28h-4v-2.668h4zM9.334 22.666h-4v-2.666h4zM26.668 28h-4.002v-2.668h4zM26.668 22.666h-4.002v-2.666h4zM26.668 17.332h-4.002v-2.666h4z"
                                  ></path>
                              </svg>
                          </div>
                          <div>
                              <dl class="mb-0">
                                  <dt class="d-block">الإقتراحات</dt>
                                  <dd class="mb-0 fs-4 fw-bold">{{ contactSuggestStatistics }}</dd>
                              </dl>
                          </div>
                      </div>
                  </div>
                  <hr/>
                  <div class="d-flex justify-content-around">
                      <dl class="mb-0">
                          <dt class="d-block">الملاك</dt>
                          <dd class="mb-0 fs-4 fw-bold">{{ ownersStatistics }}</dd>
                      </dl>
                      <dl class="mb-0">
                          <dt class="d-block">المستأجرين</dt>
                          <dd class="mb-0 fs-4 fw-bold">{{ customersCount }}</dd>
                      </dl>
                      <dl class="mb-0">
                          <dt class="d-block">الوحدات العقارية</dt>
                          <dd class="mb-0 fs-4 fw-bold">{{ realestatesCount }}</dd>
                      </dl>
                  </div>
              </div>
              <div
                      class="d-flex align-items-center justify-content-between gap-2 position-relative rounded-3 border py-2 px-3"
              >
                  <div class="d-flex align-items-center gap-3">
                      <div
                              class="rounded-3 fs-5 text-white bg-primary"
                              style="padding: 0.4rem 0.75rem"
                      >
                          <span class="bi bi-app-indicator"></span>
                      </div>
                      <div>
                          <dl class="mb-0">
                              <dt class="d-block">
                                  <router-link to="" class="link-overlay"
                                  >طلبات التذكير</router-link
                                  >
                              </dt>
                              <dd class="mb-0 lh-sm">
                                  <span class="fs-4 fw-bold align-middle">{{ reminderOrdersCount }}</span>&nbsp;
                                  <!-- <small class="text-muted align-middle">المتبقي</small> -->
                              </dd>
                          </dl>
                      </div>
                  </div>
                  <div class="bg-light rounded-3 py-1 px-2 fs-5">
                      <i class="bi bi-chevron-left"></i>
                  </div>
              </div>
          </div>
      </div>
      <div class="col-xl-6">
          <div class="d-flex gap-3 mb-3">
              <div
                      class="d-flex flex-column align-items-center justify-content-around rounded-4 p-4 bg-white w-100"
                      style="height: 184px"
              >
        <span
                class="text-success fs-4 border rounded-3"
                style="padding: 0.4rem 0.75rem"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                  fill="currentColor"
          >
            <path
                    d="M9.334 13.334h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736 0.596-1.332 1.332-1.332 0.001 0 0.001 0 0.002 0h16c0 0 0.001 0 0.002 0 0.736 0 1.332 0.596 1.332 1.332 0 0.001 0 0.001 0 0.002v-0 8h-2.668v-6.668h-13.334z"
            ></path>
            <path
                    d="M31.126 32h-4.559c-0.224-1.529-0.752-2.9-1.522-4.102l0.025 0.041h1.996v-2.707h-4.061v0.31c-1.468-1.276-3.32-2.146-5.36-2.419l-0.053-0.006v-0.403c2.798-0.609 4.862-3.064 4.862-6.002 0-2.811-1.891-5.181-4.47-5.907l-0.043-0.010c0.248-0.276 0.605-0.448 1.003-0.448 0.003 0 0.005 0 0.008 0h12.178c0.744 0 1.347 0.603 1.347 1.347v0 18.951c0 0.002 0 0.004 0 0.007 0 0.744-0.603 1.347-1.347 1.347-0.001 0-0.002 0-0.004 0h0zM23.005 19.821v2.705h4.061v-2.705zM23.005 14.408v2.707h4.061v-2.707zM5.912 32h-4.564c-0.744 0-1.347-0.603-1.347-1.347v0-13.538c0-0.744 0.603-1.347 1.347-1.347v0h8.758c-0.049 0.286-0.077 0.615-0.077 0.951v0c0.050 2.913 2.090 5.335 4.817 5.967l0.042 0.008v0.436c-2.094 0.3-3.943 1.178-5.426 2.467l0.013-0.011v-0.354h-4.061v2.707h2.021c-0.755 1.158-1.29 2.529-1.509 4.003l-0.007 0.056zM5.406 19.821v2.705h4.067v-2.705z"
            ></path>
            <path
                    d="M16.281 11.944c0.027-0.001 0.059-0.001 0.092-0.001 2.758 0 4.994 2.236 4.994 4.994s-2.236 4.994-4.994 4.994c-0.032 0-0.064-0-0.097-0.001l0.005 0c-0.005 0-0.011 0-0.018 0-2.775 0-5.030-2.225-5.079-4.987l-0-0.005c0.048-2.768 2.304-4.994 5.079-4.994 0.006 0 0.012 0 0.019 0h-0.001z"
            ></path>
            <path
                    d="M16.281 24.426c4.408 0.038 8.044 3.294 8.676 7.53l0.006 0.049h-17.448c0.674-4.297 4.336-7.549 8.763-7.579l0.003-0z"
            ></path>
          </svg>
        </span>
                  <span class="fs-4 fw-bold">{{ customersCount }}</span>
                  <small class="text-muted">المستأجرين</small>
              </div>
              <div
                      class="d-flex flex-column align-items-center justify-content-around rounded-4 p-4 bg-white w-100"
                      style="height: 184px"
              >
        <span
                class="text-warning fs-4 border rounded-3"
                style="padding: 0.4rem 0.75rem"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                  fill="currentColor"
          >
            <path
                    d="M9.332 13.334h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736 0.596-1.332 1.332-1.332 0.001 0 0.001 0 0.002 0h16c0 0 0.001 0 0.002 0 0.736 0 1.332 0.596 1.332 1.332 0 0.001 0 0.001 0 0.002v-0 8h-2.668v-6.668h-13.334z"
            ></path>
            <path
                    d="M30.666 10.666h-12c-0 0-0.001 0-0.002 0-0.736 0-1.332 0.596-1.332 1.332 0 0.001 0 0.001 0 0.002v-0 17.332h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736-0.596-1.332-1.332-1.332-0.001 0-0.001 0-0.002 0h-11.998c-0 0-0.001 0-0.002 0-0.736 0-1.332 0.596-1.332 1.332 0 0.001 0 0.001 0 0.002v-0 13.334c0 0 0 0.001 0 0.002 0 0.736 0.596 1.332 1.332 1.332 0.001 0 0.001 0 0.002 0h29.332c0 0 0.001 0 0.002 0 0.736 0 1.332-0.596 1.332-1.332 0-0.001 0-0.001 0-0.002v0-18.666c0-0.001 0-0.001 0-0.002 0-0.736-0.596-1.332-1.332-1.332-0.001 0-0.001 0-0.002 0h0zM9.334 28h-4v-2.668h4zM9.334 22.666h-4v-2.666h4zM26.668 28h-4.002v-2.668h4zM26.668 22.666h-4.002v-2.666h4zM26.668 17.332h-4.002v-2.666h4z"
            ></path>
          </svg>
        </span>
                  <span class="fs-4 fw-bold">{{ realestatesCount }}</span>
                  <small class="text-muted">الوحدات العقارية</small>
              </div>
              <div
                      class="d-flex flex-column align-items-center justify-content-around rounded-4 p-4 bg-white w-100"
                      style="height: 184px"
              >
        <span
                class="text-danger fs-4 border rounded-3"
                style="padding: 0.4rem 0.75rem"
        >
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                  fill="currentColor"
          >
            <path
                    d="M9.334 13.334h-2.666v-12c0-0 0-0.001 0-0.002 0-0.736 0.596-1.332 1.332-1.332 0.001 0 0.001 0 0.002 0h16c0 0 0.001 0 0.002 0 0.736 0 1.332 0.596 1.332 1.332 0 0.001 0 0.001 0 0.002v-0 8h-2.668v-6.668h-13.334z"
            ></path>
            <path
                    d="M31.126 32h-4.559c-0.224-1.529-0.752-2.9-1.522-4.102l0.025 0.041h1.996v-2.707h-4.061v0.31c-1.468-1.276-3.32-2.146-5.36-2.419l-0.053-0.006v-0.403c2.798-0.609 4.862-3.064 4.862-6.002 0-2.811-1.891-5.181-4.47-5.907l-0.043-0.010c0.248-0.276 0.605-0.448 1.003-0.448 0.003 0 0.005 0 0.008 0h12.178c0.744 0 1.347 0.603 1.347 1.347v0 18.951c0 0.002 0 0.004 0 0.007 0 0.744-0.603 1.347-1.347 1.347-0.001 0-0.002 0-0.004 0h0zM23.005 19.821v2.705h4.061v-2.705zM23.005 14.408v2.707h4.061v-2.707zM5.912 32h-4.564c-0.744 0-1.347-0.603-1.347-1.347v0-13.538c0-0.744 0.603-1.347 1.347-1.347v0h8.758c-0.049 0.286-0.077 0.615-0.077 0.951v0c0.050 2.913 2.090 5.335 4.817 5.967l0.042 0.008v0.436c-2.094 0.3-3.943 1.178-5.426 2.467l0.013-0.011v-0.354h-4.061v2.707h2.021c-0.755 1.158-1.29 2.529-1.509 4.003l-0.007 0.056zM5.406 19.821v2.705h4.067v-2.705z"
            ></path>
            <path
                    d="M16.281 11.944c0.027-0.001 0.059-0.001 0.092-0.001 2.758 0 4.994 2.236 4.994 4.994s-2.236 4.994-4.994 4.994c-0.032 0-0.064-0-0.097-0.001l0.005 0c-0.005 0-0.011 0-0.018 0-2.775 0-5.030-2.225-5.079-4.987l-0-0.005c0.048-2.768 2.304-4.994 5.079-4.994 0.006 0 0.012 0 0.019 0h-0.001z"
            ></path>
            <path
                    d="M16.281 24.426c4.408 0.038 8.044 3.294 8.676 7.53l0.006 0.049h-17.448c0.674-4.297 4.336-7.549 8.763-7.579l0.003-0z"
            ></path>
          </svg>
        </span>
                  <span class="fs-4 fw-bold">{{ ownersStatistics }}</span>
                  <small class="text-muted">الملاك</small>
              </div>
          </div>
          <div class="bg-white p-4 rounded-4">
              <div
                      class="mb-4 d-flex align-items-center justify-content-between"
              >
                  <h3 class="fw-bold fs-5">إحصائية الأداء</h3>
                  <!-- <select
                          name=""
                          id=""
                          class="form-select form-select-sm w-auto"
                          style="min-width: 124px"
                  >
                      <option value="1">هذا الشهر</option>
                  </select> -->
              </div>
              <!-- <div>
                  <div class="d-flex gap-3 align-content-center mb-4">
                      <dl>
                          <dt class="d-block">
              <span
                      class="d-inline-block border border-3 rounded-circle border-primary"
                      style="width: 0.75em; height: 0.75em"
              ></span>
                              <span>هذا الإسبوع</span>
                          </dt>
                          <dd class="fw-bold ms-3">75%</dd>
                      </dl>
                      <dl>
                          <dt class="d-block">
              <span
                      class="d-inline-block border border-3 rounded-circle border-danger"
                      style="width: 0.75em; height: 0.75em"
              ></span>
                              <span>الأسبوع الفائت</span>
                          </dt>
                          <dd class="fw-bold ms-3">71%</dd>
                      </dl>
                      <div class="w-25 ms-auto">
                          <div
                                  class="mb-1 d-flex justify-content-between align-content-center"
                          >
                              <small class="text-muted">متوسط الاداء</small>
                              <strong>60%</strong>
                          </div>
                          <div class="progress">
                              <div
                                      class="progress-bar"
                                      role="progressbar"
                                      aria-label="Basic example"
                                      style="width: 60%"
                                      aria-valuenow="60"
                                      aria-valuemin="0"
                                      aria-valuemax="100"
                              ></div>
                          </div>
                      </div>
                  </div>
              </div> -->
              <!-- <canvas id="chart"></canvas> -->
                <DoughnutChart ref="doughnutRef" :chartData="test" :options="options" />
          </div>
      </div>
  </div>

</template>


<script>
import { defineComponent } from 'vue';
import { DoughnutChart } from 'vue-chart-3';
import { Chart, registerables } from "chart.js";
import { ref, reactive, computed, onMounted } from 'vue'
import { mapGetters } from 'vuex'

import axios from 'axios';
Chart.register(...registerables);

export default{
name: 'DashBoard',
components: { DoughnutChart },
data(){
  return {
    customersCount: 0,
    realestatesCount: 0,
    reminderOrdersCount: 0,
    realestatesVacant: 0,
    ownersStatistics: 0,
    contactSuggestStatistics: 0,
    contactSupportStatistics: 0,
    realestatesRent: 0,
    fullPage: false,
  }
},

methods: {
  async getCustomers(){
    let loader = this.$loading.show({
          color: '#0d6efd',
          loader: 'dots',
          backgroundColor: '#e4e4e4',
      });
      const response = await axios.get(`${localStorage.getItem('default_office')}/customerStatistics`)
      this.customersCount = response.data.count;
      loader.hide()
    },
    async getRealestates(){
      const response = await axios.get(`${localStorage.getItem('default_office')}/realestateStatistics`)
      // console.log(response.data.count)
      this.realestatesCount = response.data.count;

    },
    
    async getReminderOrders(){
      const response = await axios.get(`${localStorage.getItem('default_office')}/reminderOrderStatistics`)
      this.reminderOrdersCount = response.data.count;
    },

    async getRealestatesVacant(){
      const response = await axios.get(`${localStorage.getItem('default_office')}/realestateStatisticsVacant`)
        this.realestatesVacant = response.data.count;
    },

    async getOwnersStatistics(){
      const response = await axios.get(`${localStorage.getItem('default_office')}/ownersStatistics`)
        this.ownersStatistics = response.data.count;
    },
    async getContactSuggestStatistics(){
      const response = await axios.get(`${localStorage.getItem('default_office')}/contactSuggestStatistics`)
        this.contactSuggestStatistics = response.data.count;
    },
    async getContactSupportStatistics(){
      const response = await axios.get(`${localStorage.getItem('default_office')}/contactSupportStatistics`)
        this.contactSupportStatistics = response.data.count;
    },
    async getrealestateRentStatistics(){
      const response = await axios.get(`${localStorage.getItem('default_office')}/realestateStatisticsRent`)
      this.realestatesRent = response.data.count;
    },
    
},
computed: {

  ...mapGetters({
    authenticated: 'auth/authenticated',
    user: 'auth/user'
  }),

  test(){
        const statistics =  {
          labels: ['المستأجرين', 'الوحدات العقارية', 'طلبات التذكير', 'وحدات شاغرة', 'ملاك العقار', 'الاقتراحات', 'طلبات الدعم', 'الوحدات المؤجرة'],
          datasets: [
            {
              data: [
                      this.customersCount,
                      this.realestatesCount,
                      this.reminderOrdersCount,
                      this.realestateVacant,
                      this.ownersStatistics,
                      this.contactSuggestStatistics,
                      this.contactSupportStatistics,
                      this.realestatesRent

                    ],
              backgroundColor: ['#77CEFF', '#0079AF', '#123E6B', '#97B0C4', '#A5C8ED'],
            },
          ],
        }
        return statistics;
    },

      
  },

  mounted(){

    if(this.user){
      
      this.getCustomers();
      this.getRealestates();
      this.getReminderOrders();
      this.getRealestatesVacant();
      this.getOwnersStatistics();
      this.getContactSuggestStatistics();
      this.getContactSupportStatistics();
      this.getrealestateRentStatistics();
      
    }

  }

}
</script>


